// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountMaintenanceFeesAmountPropertyDto
 */
export interface IAccountMaintenanceFeesAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountMaintenanceFeesAmountPropertyDto
     */
    account_maintenance_fees_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountMaintenanceFeesAmountPropertyDto
     */
    account_maintenance_fees_amount_state?: IAccountMaintenanceFeesAmountPropertyDtoAccountMaintenanceFeesAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountMaintenanceFeesAmountPropertyDtoAccountMaintenanceFeesAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAccountMaintenanceFeesAmountPropertyDto interface.
 */
export function instanceOfIAccountMaintenanceFeesAmountPropertyDto(value: object): value is IAccountMaintenanceFeesAmountPropertyDto {
    return true;
}

export function IAccountMaintenanceFeesAmountPropertyDtoFromJSON(json: any): IAccountMaintenanceFeesAmountPropertyDto {
    return IAccountMaintenanceFeesAmountPropertyDtoFromJSONTyped(json, false);
}

export function IAccountMaintenanceFeesAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountMaintenanceFeesAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_maintenance_fees_amount': json['account_maintenance_fees_amount'] == null ? undefined : json['account_maintenance_fees_amount'],
        'account_maintenance_fees_amount_state': json['account_maintenance_fees_amount_state'] == null ? undefined : json['account_maintenance_fees_amount_state'],
    };
}

export function IAccountMaintenanceFeesAmountPropertyDtoToJSON(json: any): IAccountMaintenanceFeesAmountPropertyDto {
    return IAccountMaintenanceFeesAmountPropertyDtoToJSONTyped(json, false);
}

export function IAccountMaintenanceFeesAmountPropertyDtoToJSONTyped(value?: IAccountMaintenanceFeesAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_maintenance_fees_amount': value['account_maintenance_fees_amount'],
        'account_maintenance_fees_amount_state': value['account_maintenance_fees_amount_state'],
    };
}

